import { render, staticRenderFns } from "./isi-info.vue?vue&type=template&id=d7d7d80a&scoped=true&"
import script from "./isi-info.vue?vue&type=script&lang=ts&"
export * from "./isi-info.vue?vue&type=script&lang=ts&"
import style0 from "./isi-info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./isi-info.vue?vue&type=style&index=1&id=d7d7d80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d7d80a",
  null
  
)

export default component.exports